import React, { useState, useEffect, useRef } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../../_metronic/_helpers";
import {
  Input,
  Pagination,
} from "../../../../../../_metronic/_partials/controls";
import * as donaturActions from "../../../../Donatur/_redux/donatur/donaturAction";
import AddIcon from "@material-ui/icons/Add";
import { Field, Formik } from "formik";
import { findDonaturs } from "../../../../Donatur/_redux/donatur/donaturCrud";

export default function SelectDonaturModal({ show, onHide, selectedDonatur }) {
  const formRef = useRef();

  const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "20", value: 20 },
    { text: "50", value: 50 },
  ];

  const [queryParams, setQueryParams] = useState({
    pageNumber: 1,
    pageSize: 10,
    filter: {
      name: "",
      kd_cc: "",
      email: "",
      hp: "",
      city: "",
      provinsi: "",
      type: "",
      branch: "",
      start_date: "",
      end_date: "",
      is_letter: "",
      filterCabang: true,
    },
  });

  // Getting curret state of branch list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.donaturs }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  useEffect(() => {
    if (!show) {
      setQueryParams((prevState) => ({
        ...prevState,
        pageNumber: 1,
        pageSize: 10,
        filter: {},
      }));
    }
  }, [show]);

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Donatur Action
    if (show) {
      formRef.current.resetForm();
      dispatch(donaturActions.fetchDonaturs(queryParams));
      //   findDonaturs(queryParams).then((res) => console.log(res.data.data.items));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams, dispatch, show]);

  const columns = [
    {
      dataField: "name",
      text: "Nama",
    },
    {
      dataField: "hp",
      text: "HP",
    },
    {
      dataField: "email",
      text: "Email",
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: (cell, row) => {
        return (
          <>
            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Pilih</Tooltip>}
            >
              <a
                className="btn btn-icon btn-light btn-hover-success btn-sm mx-3"
                onClick={() => selectedDonatur(row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-success">
                  <AddIcon />
                </span>
              </a>
            </OverlayTrigger>
          </>
        );
      },
      classes: "text-right",
      headerClasses: "text-right",
    },
  ];

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
  };

  const applyFilter = (value) => {
    const { name, hp, email } = value;
    setQueryParams((prevState) => ({
      ...prevState,
      filter: {
        name,
        hp,
        email,
      },
    }));
  };

  return (
    <>
      <Modal
        size="lg"
        show={show}
        onHide={onHide}
        aria-labelledby="modal-sizes-title-lg"
      >
        <Modal.Header>
          <h4>Pilih Donatur</h4>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize={true}
            initialValues={{}}
            onSubmit={(values) => applyFilter(values)}
            innerRef={formRef}
          >
            {({ handleSubmit, setFieldValue, values }) => (
              <>
                <div className="row">
                  <div className="col">
                    <Field
                      name="name"
                      component={Input}
                      onChange={(e) => {
                        setFieldValue("name", e.target.value);
                        handleSubmit();
                      }}
                      label="name"
                      placeholder="Masukkan nama..."
                    />
                  </div>
                  <div className="col">
                    <Field
                      name="hp"
                      component={Input}
                      onChange={(e) => {
                        setFieldValue("hp", e.target.value);
                        handleSubmit();
                      }}
                      label="hp"
                      placeholder="Masukkan hp..."
                    />
                  </div>
                  <div className="col">
                    <Field
                      name="email"
                      component={Input}
                      onChange={(e) => {
                        setFieldValue("email", e.target.value);
                        handleSubmit();
                      }}
                      label="email"
                      placeholder="Masukkan email..."
                    />
                  </div>
                </div>
              </>
            )}
          </Formik>
        </Modal.Body>
        <Modal.Body>
          <PaginationProvider pagination={paginationFactory(paginationOptions)}>
            {({ paginationProps, paginationTableProps }) => {
              return (
                <Pagination
                  isLoading={listLoading}
                  paginationProps={paginationProps}
                >
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    bordered={false}
                    remote
                    keyField="uuid"
                    data={entities === null ? [] : entities}
                    columns={columns}
                    onTableChange={getHandlerTableChange(setQueryParams)}
                    {...paginationTableProps}
                  >
                    <PleaseWaitMessage entities={entities} />
                    <NoRecordsFoundMessage entities={entities} />
                  </BootstrapTable>
                </Pagination>
              );
            }}
          </PaginationProvider>
        </Modal.Body>
      </Modal>
    </>
  );
}
